/* eslint-disable max-len */
import React, { useRef, useState } from 'react'
import { Form, withFormik } from 'formik'
import _map from 'lodash/map'
import _reduce from 'lodash/reduce'
import _forEach from 'lodash/forEach'
import _values from 'lodash/values'

import Button from '../../../_library/Button'
import Select from '../../../_library/Select'
import LoadingBar from '../../../_library/LoadingBar'
import Card from '../../../_library/Card'

import { useGuestTickets } from './useGuestTickets'
import { validateGuestTicketsCRM } from './validate'
import TopCustomerRegularTickets from './TopCustomerRegularTickets'
import { baseRequest, getCustomers } from '../../../../_common/core/http_services'
import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table'
import { useVirtual } from 'react-virtual'
import Field from '../../../_library/Field'
import { crmAdapter } from '../../../../_common/core/http_services/adapters'

const options_quantity = _map(new Array(40), (_, i) => ({ value: i + 1, label: i + 1 }))

const columns = [
  {
    accessorKey: 'firstName',
    header: () => <span>First Name</span>,
    cell: info => {
      const { index } = info.row
      const handleChange = info.table.options.meta?.handleChange
      const handleBlur = info.table.options.meta?.handleBlur
      const values = info.table.options.meta?.values
      const errors = info.table.options.meta?.errors
      const touched = info.table.options.meta?.touched
      return (
        <Field
          type="text"
          id={'recipients[' + index + '].firstName'}
          value={values.recipients[index].firstName}
          error={errors.recipients && errors.recipients[index] && errors.recipients[index].firstName}
          touched={
            touched.recipients && touched.recipients[index] && touched.recipients[index].firstName
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )
    },
  },
  {
    accessorKey: 'lastName',
    header: () => <span>Last Name</span>,
    cell: info => {
      const { index } = info.row
      const handleChange = info.table.options.meta?.handleChange
      const handleBlur = info.table.options.meta?.handleBlur
      const values = info.table.options.meta?.values
      const errors = info.table.options.meta?.errors
      const touched = info.table.options.meta?.touched
      return (
        <Field
          type="text"
          id={'recipients[' + index + '].lastName'}
          value={values.recipients[index].lastName}
          error={errors.recipients && errors.recipients[index] && errors.recipients[index].lastName}
          touched={
            touched.recipients && touched.recipients[index] && touched.recipients[index].lastName
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )
    },
  },
  {
    accessorKey: 'email',
    header: () => <span>Email</span>,
    cell: info => {
      const { index } = info.row
      const handleChange = info.table.options.meta?.handleChange
      const handleBlur = info.table.options.meta?.handleBlur
      const values = info.table.options.meta?.values
      const errors = info.table.options.meta?.errors
      const touched = info.table.options.meta?.touched
      return (
        <Field
          type="email"
          id={'recipients[' + index + '].email'}
          value={values.recipients[index].email}
          error={errors.recipients && errors.recipients[index] && errors.recipients[index].email}
          touched={touched.recipients && touched.recipients[index] && touched.recipients[index].email}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )
    },
  },
  {
    accessorKey: 'quantity',
    header: () => <span>Number of Tickets</span>,
    cell: info => {
      const { index } = info.row
      const handleChange = info.table.options.meta?.handleChange
      const handleBlur = info.table.options.meta?.handleBlur
      const values = info.table.options.meta?.values
      const errors = info.table.options.meta?.errors
      const touched = info.table.options.meta?.touched
      return (
        <Field
          type="number"
          id={'recipients[' + index + '].quantity'}
          value={values.recipients[index].quantity}
          error={errors.recipients && errors.recipients[index] && errors.recipients[index].quantity}
          touched={
            touched.recipients && touched.recipients[index] && touched.recipients[index].quantity
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )
    },
  },
  {
    accessorKey: 'ticketTypeName',
    header: () => <span>Type of Ticket</span>,
    cell: info => {
      const { index } = info.row
      const handleChange = info.table.options.meta?.handleChange
      const handleBlur = info.table.options.meta?.handleBlur
      const values = info.table.options.meta?.values
      const errors = info.table.options.meta?.errors
      const touched = info.table.options.meta?.touched
      const optionsTicketTypeNames = info.table.options.meta?.optionsTicketTypeNames
      return (
        <Select
          options={optionsTicketTypeNames}
          id={'recipients[' + index + '].ticketTypeName'}
          value={values.recipients[index].ticketTypeName}
          error={
            errors.recipients && errors.recipients[index] && errors.recipients[index].ticketTypeName
          }
          touched={
            touched.recipients && touched.recipients[index] && touched.recipients[index].ticketTypeName
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )
    },
  },
  {
    accessorKey: 'notes',
    header: () => <span>Notes</span>,
    cell: info => {
      const { index } = info.row
      const handleChange = info.table.options.meta?.handleChange
      const handleBlur = info.table.options.meta?.handleBlur
      const values = info.table.options.meta?.values
      const errors = info.table.options.meta?.errors
      const touched = info.table.options.meta?.touched
      return (
        <Field
          type="notes"
          id={'recipients[' + index + '].notes'}
          value={values.recipients[index].notes}
          error={errors.recipients && errors.recipients[index] && errors.recipients[index].notes}
          touched={touched.recipients && touched.recipients[index] && touched.recipients[index].notes}
          onChange={handleChange}
          onBlur={handleBlur}
        />
      )
    },
  },
  {
    size: 30,
    accessorKey: 'delete',
    header: () => <span />,
    cell: info => {
      const deleteRecipient = info.table.options.meta?.deleteRecipient
      const { index } = info.row
      return (
        <div aria-hidden className="delete-recipient"
          onClick={() => deleteRecipient(index)}
        >
          <i className="fa fa-trash" aria-hidden="true" />
        </div>
      )
    },
  },
]

const GuestTicketTopCustomer = props => {
  const {
    event,
    tickets,
    tables,
    values,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    cardsStatus,
    isSubmitting,
    submitLabel,
    ticketTypes,
    handleSubmit,
    handleBlur,
    handleChange,
    normalTickets,
  } = props

  const optionsTicketTypeNames = _map(normalTickets.concat(tables), ticket => ({
    value: ticket.displayName,
    label: ticket.displayName,
  }))
  optionsTicketTypeNames.unshift({ value: '', label: '- Select -' })
    
  const [isLoading, setIsLoading] = useState(false)

  const {
    hasRegularTickets,
    hasRegularTicketsDirectSales,
    regularTicketsNotConnectedToSeatMap,
    hasTables,
    hasTablesDirectSales,
    tablesNotConnectedToSeatMap,
  } = useGuestTickets({
    event,
    tickets,
    tables,
    seatMapConnectedIds: Array.from(
      new Set(_reduce(_values(ticketTypes), (curr, next) => [...curr, ...next], [])),
    ),
  })

  let ticketTableLabel = 'Ticket Type'
  if (hasRegularTicketsDirectSales && hasTablesDirectSales) {
    ticketTableLabel = 'Ticket/Table Type'
  } else if (hasRegularTickets) {
    ticketTableLabel = 'Ticket Type'
  } else if (hasTables) {
    ticketTableLabel = 'Table Type'
  }

  const optionsTickets = [{ value: '', label: `Select ${ticketTableLabel}` }]
  _forEach(regularTicketsNotConnectedToSeatMap, ticketItem => {
    if (ticketItem.active) {
      const key = ticketItem.displayName || ticketItem.name
      optionsTickets.push({ value: ticketItem.id || key, label: key })
    }
  })

  _forEach(tablesNotConnectedToSeatMap, tableItem => {
    if (tableItem.active) {
      const key = tableItem.displayName || tableItem.name
      optionsTickets.push({ value: tableItem.id || key, label: key })
    }
  })

  const handleChangeDefaultTicketTypeName = async ({ label, value }) => {
    try {
      setFieldValue('defaultTicketTypeName', label)
      setFieldValue('defaultTicketTypeID', value)

      if (event.flagAllowGuestTicketsByOptIns && values.quantityTopCustomers === 'all') {
        return
      }

      if (values.recipients.length === 0) {
        setIsLoading(true)
        let customers = null
        if (event.flagAllowGuestTicketsByOptIns) {
          customers = await fetchOptInsCustomers({ defaultTicketTypeName: label })
        } else {
          const { users } = await fetchCustomers({ defaultTicketTypeName: label })
          customers = users
        }
        setIsLoading(false)
        setFieldValue('recipients', customers)
      } else {
        const new_recipients = values.recipients.map(recipient => ({ ...recipient, ticketTypeName: label }))
        setFieldValue('recipients', new_recipients)
      }
    } catch (e) {
      setIsLoading(false)
    }
  }

  const handleChangeQuantity = e => {
    const v = e.target ? e.target.value : e
    setFieldValue('defaultTicketQuantity', parseInt(v))
    setFieldTouched('defaultTicketQuantity', true)
    const new_recipients = values.recipients.map(recipient => ({ ...recipient, quantity: parseInt(v) }))
    setFieldValue('recipients', new_recipients)
  }

  const fetchCustomers = async ({ quantity, defaultTicketTypeName }) => {
    const result = await getCustomers(
      '',
      quantity ?? values.quantityTopCustomers,
      1,
      event.owner.id,
      0,
      'usdRatedImpactRevenue',
      false,
      'guest_tickets',
    )
    const users = result.data.map(customer => ({
      firstName: customer.firstName,
      lastName: customer.lastName,
      email: customer.email,
      quantity: values.defaultTicketQuantity,
      ticketTypeName: defaultTicketTypeName ?? values.defaultTicketTypeName,
      notes: '',
      tags: [],
    }))
    const { total } = result.pagination
    return { users, total }
  }

  const fetchOptInsCustomers = async ({ quantity, defaultTicketTypeName }) => {
    const response = await baseRequest.get(
      `brand/${event.owner.id}/opt-ins?type=guest_tickets&limit=${quantity ?? values.quantityTopCustomers}`,
    )
    return response.data.data.customers.map(customer => ({
      firstName: customer.firstName,
      lastName: customer.lastName,
      email: customer.email,
      quantity: values.defaultTicketQuantity,
      ticketTypeName: defaultTicketTypeName ?? values.defaultTicketTypeName,
      notes: '',
      tags: '',
    }))
  }

  const handleOptInCustomersQuantity = async quantity => {
    try {
      setFieldValue('quantityTopCustomers', quantity)
      if (quantity === values.quantityTopCustomers) {
        return
      }

      if (event.flagAllowGuestTicketsByOptIns && quantity === 'all') {
        return
      }

      setIsLoading(true)
      const users = await fetchOptInsCustomers({ quantity })
      setFieldValue('recipients', users)
      setIsLoading(false)
    } catch (e) {
      setIsLoading(false)
    }
  }

  const handleTopCustomersQuantity = async quantity => {
    try {
      setFieldValue('quantityTopCustomers', quantity)
      if (quantity === values.quantityTopCustomers) {
        return
      }
      if (quantity === 'all') {
        setIsLoading(true)
        const { users, total } = await fetchCustomers({ quantity: 100 })
        const registersPerQuery = 25000
        const queriesNumber = Math.floor((total - 100) / registersPerQuery)
        const queries = []
        const getPromise = offset =>
          baseRequest.get('crm/customers', {
            params: {
              search_query: '',
              limit: registersPerQuery,
              page: '',
              brandId: event.owner.id,
              offset,
              sortBy: 'usdRatedImpactRevenue',
              sortOrder: 'desc',
              source: 'guest_tickets',
            },
          })
        for (let i = 0; i <= queriesNumber; i++) {
          queries.push(getPromise((registersPerQuery * i) + 10))
        }
        const response = await Promise.all(queries)
        const data = users.concat(response.reduce((prev, curr) => prev.concat(crmAdapter(curr.data).data), []))
        const allUsers = data.map(customer => ({
          firstName: customer.firstName,
          lastName: customer.lastName,
          email: customer.email,
          quantity: values.defaultTicketQuantity,
          ticketTypeName: values.defaultTicketTypeName,
          notes: '',
          tags: '',
        }))
        setFieldValue('recipients', allUsers)
        setIsLoading(false)
      } else {
        setIsLoading(true)
        const { users } = await fetchCustomers({ quantity })
        setFieldValue('recipients', users)
        setIsLoading(false)
      }
    } catch (e) {
      setIsLoading(false)
    }
  }

  const deleteRecipient = index => {
    const recipients = [...values.recipients]
    recipients.splice(index, 1)
    setFieldValue('recipients', recipients)
  }

  const handleMultiSelect = (id, value) => {
    setFieldValue(id, value)
  }

  const [columnVisibility, setColumnVisibility] = useState({})

  const tableContainerRef = useRef(null)

  const table = useReactTable({
    data: values.recipients,
    columns,
    getCoreRowModel: getCoreRowModel(),
    onColumnVisibilityChange: setColumnVisibility,
    debugTable: true,
    state: {
      columnVisibility,
    },
    meta: {
      values,
      errors,
      touched,
      deleteRecipient,
      handleChange,
      handleBlur,
      optionsTicketTypeNames,
      handleMultiSelect,
    },
  })

  const { rows } = table.getRowModel()

  const rowVirtualizer = useVirtual({
    parentRef: tableContainerRef,
    size: rows.length,
    overscan: 5,
    estimateSize: React.useCallback(() => 62, []),
  })
  const { virtualItems: virtualRows, totalSize } = rowVirtualizer
  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0
  const paddingBottom =
    virtualRows.length > 0 ? totalSize - (virtualRows?.[virtualRows.length - 1]?.end || 0) : 0
  const directGuestTickets = (event.flagAllowGuestTicketsByOptIns && values.quantityTopCustomers === 'all')
  
  return (
    <div>
      <Form>
        <Card
          title={
            event.flagAllowGuestTicketsByOptIns
              ? `Send Guest Ticket to opt in customers`
              : `Send Guest Tickets to Top ${event.owner.displayName} Customers`
          }
          className="guest-ticket-form"
          status={cardsStatus && cardsStatus.form}
        >
          {
            <div>
              {hasRegularTicketsDirectSales || hasTablesDirectSales ? (
                <TopCustomerRegularTickets
                  handleTopCustomersQuantity={
                    event.flagAllowGuestTicketsByOptIns
                      ? handleOptInCustomersQuantity
                      : handleTopCustomersQuantity
                  }
                  values={values}
                  ticketTableLabel={ticketTableLabel}
                  optionsTickets={optionsTickets}
                  errors={errors}
                  touched={touched}
                  options_quantity={options_quantity}
                  handleChangeTicketTypeID={handleChangeDefaultTicketTypeName}
                  handleChangeQuantity={handleChangeQuantity}
                />
              ) : null}
              {values?.recipients?.length && !directGuestTickets ? (
                <div
                  ref={tableContainerRef}
                  style={{ height: 500, overflow: 'auto' }}
                  className="recipients-table-container"
                >
                  {isLoading ? (
                    <LoadingBar />
                  ) : (
                    <table style={{ tableLayout: 'fixed', width: '100%' }} className="table recipients-table">
                      <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                        {table.getHeaderGroups().map(headerGroup => (
                          <tr key={headerGroup.id}>
                            {headerGroup.headers.map(header => (
                              <th
                                key={header.id}
                                colSpan={header.colSpan}
                                style={{ width: header.getSize(), padding: '8px 20px' }}
                              >
                                <div>{flexRender(header.column.columnDef.header, header.getContext())}</div>
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody>
                        {paddingTop > 0 && (
                          <tr>
                            <td style={{ height: `${paddingTop}px` }} />
                          </tr>
                        )}
                        {virtualRows.map(virtualRow => {
                          const row = rows[virtualRow.index]
                          return (
                            <tr key={row.id}>
                              {row.getVisibleCells().map(cell => (
                                <td style={{ padding: 6 }} key={cell.id}>
                                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                              ))}
                            </tr>
                          )
                        })}
                        {paddingBottom > 0 && (
                          <tr>
                            <td style={{ height: `${paddingBottom}px` }} />
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              ) : null}
              <div className="row">
                <div className="col-xs-12 col-12">
                  <br />
                  <div className="display-inline-block">
                    <Button
                      className={'btn btn-primary btn-shadow'}
                      type="button"
                      loading={isSubmitting}
                      disabled={isLoading || (!values.recipients.length && !directGuestTickets)}
                      onClick={() => {
                        handleSubmit(values, { ...props })
                      }}
                    >
                      {submitLabel || 'Issue Tickets'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          }
        </Card>
      </Form>
    </div>
  )
}

export const GuestTicketTopCustomerFormContainer = withFormik({
  mapPropsToValues: () => ({
    defaultTicketTypeName: '',
    defaultTicketTypeID: '',
    defaultTicketQuantity: 1,
    defaultAddOns: [],
    recipients: [],
    quantityTopCustomers: 5,
  }),

  validate: (values, props) => validateGuestTicketsCRM(values, props),

  handleSubmit: (
    values,
    { props, setSubmitting, setTouched, resetForm },
  ) => {
    props
      .onSubmit(values)
      .then(() => {
        setTouched(false)
        setSubmitting(false)
        resetForm()
      })
      .catch(err => {
        setTouched(false)
        setSubmitting(false)
      })
  },
})(GuestTicketTopCustomer)

